export default "__VITE_ASSET__2c8a14c2__"